import {Component, Input} from '@angular/core';


/**
 * A component that renders an SVG icon for "Folder"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-folder',
    templateUrl: './icon-folder.component.html',
    styleUrls: ['./icon-folder.component.scss'],
    standalone: false
})
export class IconFolderComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
